export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=404424003f2729a2e11a449d5b1a67b70588a448ec&name=revalidateCommunity!'